import type { FeatureInventory as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';

/** A declared feature flag with its adoption across the platform. */
export type FeatureInventory = {
  feature: string;
  displayName: string;
  accountCount: number;
  enabledByDefault: boolean;
};

export const fromGql = (item: GQLItem): FeatureInventory =>
  take<FeatureInventory, Pick<GQLItem, 'feature' | 'displayName' | 'accountCount' | 'enabledByDefault'>>(
    item,
    'feature',
    'displayName',
    'accountCount',
    'enabledByDefault',
  );
